const PrinciplesSection = () => {
  const principles = [
    {
      icon: 'ri-award-line',
      iconBg: 'bg-emerald-100',
      iconColor: 'text-emerald-600',
      title: 'L\'EXCELLENCE',
      description: 'Notre organisation s\'applique en permanence à atteindre le sommet de la qualité dans l\'ensemble de ses opérations. Nous avons pour objectif de livrer des services de bâtiment et d\'entretien de premier ordre, qui comblent les attentes précises de notre clientèle.'
    },
    {
      icon: 'ri-team-line',
      iconBg: 'bg-blue-100',
      iconColor: 'text-blue-600',
      title: 'LA COLLABORATION',
      description: 'Le travail d\'équipe est un pilier essentiel pour notre société. Nous mesurons l\'importance capitale de forger des partenariats solides avec nos clients, nos fournisseurs, nos prestataires logistiques et l\'ensemble de nos parties prenantes. En œuvrant de concert et en privilégiant la transparence dans les échanges, l\'entreprise est en mesure de répondre aux besoins uniques de chaque client et de proposer des réponses parfaitement adaptées.'
    },
    {
      icon: 'ri-leaf-line',
      iconBg: 'bg-teal-100',
      iconColor: 'text-teal-600',
      title: 'LA DURABILITÉ',
      description: 'Notre entreprise attache une considération majeure à la préservation de l\'environnement. Nous intégrons des méthodes éco-responsables dans toutes nos activités, en privilégiant l\'emploi de matériaux pérennes et en veillant à la protection de notre écosystème.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Nos Principes Fondateurs</h2>
          <div className="w-24 h-1 bg-gradient-to-r from-emerald-500 to-teal-500 mx-auto rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {principles.map((principle, index) => (
            <div 
              key={index} 
              className="group bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 shadow-md hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:border-emerald-200"
            >
              <div className={`w-20 h-20 ${principle.iconBg} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${principle.icon} text-4xl ${principle.iconColor}`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 tracking-tight">{principle.title}</h3>
              <p className="text-gray-600 leading-relaxed text-base">{principle.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PrinciplesSection;
